import React from "react";
import * as material from "@mui/material";
import * as styles from "@mui/material/styles";
import "./ExpeditionProgress.css";

interface Expedition {
  id: number;
  name: string;
  status: "OK" | "Pending" | "Issue" | "Limbo";
  selected: boolean;
}

interface ExpeditionProgressProps {
  expeditions: Expedition[];
  onExpeditionSelect: (id: number) => void;
}

const CustomConnector = styles.styled(material.StepConnector)(({ theme }) => ({
  "&.MuiStepConnector-root": {
    top: 10,
    right: "calc(50% + 16px)",
  },
  "&.completed .MuiStepConnector-line": {
    borderColor: "green",
  },
  "&.Mui-active .MuiStepConnector-line": {
    borderColor: "red",
  },
  "& .MuiStepConnector-line": {
    borderTopWidth: 3,
    borderRadius: 1,
    borderColor: "gray",
  },
}));

const ExpeditionProgress: React.FC<ExpeditionProgressProps> = ({
  expeditions,
  onExpeditionSelect,
}) => {
  const getStatusClass = (status: string): string => {
    switch (status) {
      case "OK":
        return "completed";
      case "Pending":
        return "pending-sts";
      case "Issue":
        return "issue-sts";
      case "Limbo":
        return "limbo-sts";
      default:
        return "";
    }
  };

  return (
    <div className="expedition-progress">
      <div className="first-expedition-line"></div>
      <material.Stepper
        activeStep={expeditions.findIndex((expedition) => expedition.selected)}
        alternativeLabel
        connector={<CustomConnector />}
      >
        <div className="stepper">
          {expeditions.map((expedition) => (
            <div
              key={expedition.id}
              className={`step ${getStatusClass(expedition.status)} ${
                expedition.selected ? "active" : ""
              }`}
              onClick={() => onExpeditionSelect(expedition.id)}
            >
              <div
                className={`step-label ${
                  expedition.selected ? "fill" : ""
                }`}
              ></div>
                 <div
                className={`step-description ${
                  expedition.selected ? "selected" : ""
                }`}
              >
                {expedition.name}
              </div>
            </div>
          ))}
        </div>
      </material.Stepper>
    </div>
  );
};

export default ExpeditionProgress;
